/*
 * @Author: amywulan
 * @description: pc 登录基础配置，目前默认配置为C交易配置，不同业务可以修改对应的配置
 * @doc: https://base.xiaojukeji.com/docs/passport/259
 */
import { getLanguageLong } from '@/utils/locale';
import { isH5 } from '@/utils/tools';

const getLanguage =
  getLanguageLong() === 'es-419' ? 'es-MX' : getLanguageLong();
import config from '@/config/index';
const cApi = config.cApiBase;
export default {
  passport: {
    /** 美东正式地址 **/
    passportUrl:
      'https://page.didiglobal.com/public-biz/pc-login/3.1.2/index.html',
    // 'https://passport-test.didichuxing.com/static/pc-login/3.1.0/index.html',

    h5LoginUrl:
      'https://static.didiglobal.com/common-biz/global-login/2.0.9/login.global.min.js',
    /** 回调地址为后端setCookie接口地址 **/
    setCookieUrl: `${cApi}/login/callback`,

    /** 登录后跳转至url **/
    redirectUrl: '',

    /** passport分配的appid **/
    //todo 测试未加入200044在验证码内，先用120838的
    appId: isH5 ? 200066 : 200044,

    /** 来源，根据国家区分 **/
    source: 70001,

    /** 角色 **/
    role: 1,

    /** 页面语言 **/
    lang: getLanguage,

    /** 默认选中的国家id,传入时支持默认显示对应国家码手机号前缀（http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=114390267） **/
    country_id: 484,

    /** 默认true，自动填充上一次手机号 **/
    auto_fill_phone: true,

    /** 系统主题 默认滴滴桔，巴西99黄传yellow **/
    theme: void 0,
    law_url:
      'https://privacycenter.didiglobal.com/MX/privacy-notice/8c2abedad3d0914634eb51f494e3538d/Mexico',
    country_calling_code: '+52',
    city_id: 0,
    canonical_country_code: 'MX',
  },
};
